<template>
  <div :class="customClasses" @click="toggleClick"></div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ElementToggle',
  props: {
    active: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      className: 'toggle'
    }
  },
  computed: {
    ...mapGetters({
      device: 'breakpoints/getDevice'
    }),
    customClasses () {
      return [
        this.className,
        { 'is-active': this.active }
      ]
    }
  },
  methods: {
    toggleClick: function (event) {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss">
  .toggle{
    @include icon(icons('menu'), "before");
    @include size(4rem);

    display: block;
    cursor: pointer;
    color: colors("primary");
    transition: all 300ms ease-in-out;

    &.is-active{
      color: shade(colors("primary"), 20%);
      transform: rotate(90deg);
    }

    &::before{
      font-size: 4rem;
      line-height: 1;
    }

    &:hover{
      color: shade(colors("primary"), 10%);
    }
  }
</style>
